export const positionSymbolHeaderTemplate = 
`<div class="ag-cell-label-container ag-header-cell-sorted-none" role="presentation">
<span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
<span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button"></span>
<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
  <span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
  <span data-ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>
  <span data-ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>
  <span data-ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>
  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
  <span data-ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
</div>
</div>`

export const costBasisHeaderTemplate = 
`<div class="ag-cell-label-container" role="presentation">
<span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
<span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button"></span>
<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
  <span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
  <span data-ref="eSortAsc"></span>
  <span data-ref="eSortDesc"></span>
  <span data-ref="eSortNone"></span>
  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
  <span data-ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
</div>
</div>`

export const currPricePerShareHeaderTemplate = 
`<div class="ag-cell-label-container role="presentation">
<span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
<span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button"></span>
<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
  <span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
  <span data-ref="eSortAsc"></span>
  <span data-ref="eSortDesc"></span>
  <span data-ref="eSortNone"></span>
  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
  <span data-ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
</div>
</div>`


export const totalCostBasisHeaderTemplate = 
`<div class="ag-cell-label-container" role="presentation">
<span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
<span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button"></span>
<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
  <span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
  <span data-ref="eSortAsc"></span>
  <span data-ref="eSortDesc"></span>
  <span data-ref="eSortNone"></span>
  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
  <span data-ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
</div>
</div>`

export const estMarketValHeaderTemplate = 
`<div class="ag-cell-label-container" role="presentation">
<span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
<span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button"></span>
<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
  <span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
  <span data-ref="eSortAsc"></span>
  <span data-ref="eSortDesc"></span>
  <span data-ref="eSortNone"></span>
  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
  <span data-ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
</div>
</div>`